import React from 'react';
import {
  HelpLink,
  Card,
  Stack,
  withTranslation,
} from '@piwikpro/ui-components';
import { errorBoundary } from '@piwikpro/platform';
import TrackingECommerce from './TrackingECommerce';
import SharepointIntegration from './SharepointIntegration';

class Integrations extends React.Component {
  render() {
    return (
      <Stack vertical spacing="wide">
        <Stack.Item fill>
          <Card>
            <Card.Section>
              <Stack vertical horizontalAlignment="middle">
                <Stack.Item fill>
                  <TrackingECommerce />
                </Stack.Item>
                <Stack.Item>
                  <HelpLink href="https://help.piwik.pro/support/getting-started/track-ecommerce/">
                    Track ecommerce
                  </HelpLink>
                </Stack.Item>
              </Stack>
            </Card.Section>
          </Card>
        </Stack.Item>
        <Stack.Item fill>
          <Card>
            <Card.Section>
              <Stack vertical horizontalAlignment="middle">
                <Stack.Item fill>
                  <SharepointIntegration />
                </Stack.Item>
                <Stack.Item>
                  <HelpLink href="https://help.piwik.pro/support/integrations/sharepoint-integration/">
                    SharePoint integration
                  </HelpLink>
                </Stack.Item>
              </Stack>
            </Card.Section>
          </Card>
        </Stack.Item>
      </Stack>
    );
  }
}

export default withTranslation(['administration'])(errorBoundary(Integrations));
